import React from 'react';
import ModRouter from './ModRouter';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SignIn from '../components/SignIn/SignIn';
import SignInSparsh from '../components/SignIn/SignInSparsh';


const RouteWithPlant = () => {
    const isAuth = useSelector((state) => state.isAuth);
    console.log(isAuth, 'loginCheck');
    return (
        <>
            {
                isAuth ?
                    <Switch>
                        <Route path="/v02/:urlCode" component={ModRouter} />
                        <Route path="/v02/:urlCode/login" component={SignIn} />
                        <Route exact path="/v02/:urlCode/sparsh" component={SignInSparsh} />
                        <Redirect from='*' to={`/v02/${localStorage.getItem('urlCode') || 'uc'}/dashboard`} />
                    </Switch> :
                    <Switch>
                        <Route path="/v02/:urlCode" component={SignIn} />
                        <Route exact path="/v02/:urlCode/sparsh" component={SignInSparsh} />
                        <Redirect from='*' to={`/v02/${localStorage.getItem('urlCode') || 'uc'}/login`} />
                    </Switch>
            }
        </>
    )
};

export default RouteWithPlant;